import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/appContext";
import { useSearchContext } from "../context/search";
import useCurrentUser from "../hooks/useCurrentUser";
import { PERMISSIONS } from "../lib/permissions";

/**
 * allow: the permission needed to open the page (see lib/permissions). Without it the user is sent
 * to their landing page, so a page cannot be reached by typing its URL either.
 */
export default function ProtectedRoute({ search = false, allow, children }) {
	const { items } = useAppContext();
	const { isUserLogin } = items;
	const currentUser = useCurrentUser({ enabled: isUserLogin === true });

	const {
		state: { phrase },
	} = useSearchContext();

	if (typeof isUserLogin !== "boolean") {
		return null;
	}
	if (!isUserLogin) {
		return <Navigate to="/" replace></Navigate>;
	}
	if (allow) {
		if (currentUser.isLoading) return null;
		if (!currentUser.can(allow)) {
			return <Navigate to={currentUser.homePath} replace></Navigate>;
		}
	}
	if (phrase !== "" && !search && currentUser.can("viewDecisions")) return <Navigate to="/search" replace></Navigate>;
	return children;
}

ProtectedRoute.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	search: PropTypes.bool,
	allow: PropTypes.oneOf(Object.keys(PERMISSIONS)),
};
